import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService, RoutingStateService,NewOrderService} from '../services';
import { CookieService } from 'ngx-cookie';
import { PendingApprovalService } from 'app/about/pending-approval/pending-approval-service.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  constructor(
    private router      : Router, 
		private orderService: NewOrderService,
    private route       : ActivatedRoute,
    private auth        : AuthService,
    private cookies     :CookieService,
    private routingState: RoutingStateService,
    private pendingApprovalService: PendingApprovalService
  ) { }

  ngOnInit() {   
    this.auth.serverHealthCheck()
    .subscribe((res)=>{
      if(res.statusText == 'OK'){
        this.route.params.subscribe((params) => {
          if(params['cookie'] && params['cookie'] !== 'link-expired'){
            let cookieObj=JSON.parse(params['cookie']);
            cookieObj['user']['User_Code'] = cookieObj['user']['Is_Active'] || cookieObj['user']['User_Code'];
            delete cookieObj['user']['Is_Active'];
            this.cookies.put('pippinTitleUsr', JSON.stringify(cookieObj)); 
            this.auth.init().subscribe(() => {
              const quoteId = cookieObj?.quoteID;
              if (quoteId) {
                this.auth.checkServerLogin().subscribe({
                  next: (status:boolean) => {
                    if(status){
                      this.auth.setMultiAccountStatus(false);
                      this.router.navigate(['quote', quoteId, 'view'], {queryParams: { action: params['action'] }});
                    }
                    return;
                  },
                  error: (err) => {
                  }
                });
                return;
              }
              this.handleLoggedInNavigation();
            })
            this.auth.isMultiCliLogin(); 
            this.auth.removeOrg();
          }
          else if (params['cookie'] === 'link-expired') {
            this.router.navigate(['/login','expired-link']);
          }
          else if(this.auth.isLoggedIn()) {
            const currentCookie = this.auth.getFullCookie();
            if(currentCookie){
              const userId = this.auth.getUserId();
              if (!currentCookie['token']) {
                this.router.navigate([`termsandconditions/${userId}`]);
                return;
              }
              if(!currentCookie['isMultiCliLogin'] ) {
                this.pendingApprovalService.checkIfOnboardingComplete(currentCookie['CompanyAccounts'][0] ? currentCookie['CompanyAccounts'][0] : null).subscribe((res) => {
                  if(!res.isOnboardingComplete){ 
                      this.router.navigate(['pendingApproval/' + userId]).then();
                      return;
                  }
                })
              }
              // if (currentCookie['isApprovalMissing']) {
              //   this.router.navigate([`pendingApproval/${userId}`]);
              //   return;
              // }
            }
            this.handleLoggedInNavigation();
            this.orderService.resetAll();
            this.routingState.clearHistory();
          }
          else this.router.navigate(['/login']);
        }); 
      }
      
    })
      
  }

  ngAfterViewInit() {
    if(this.auth.isLoggedIn()) this.auth.init().subscribe((res) => {});
  }

  handleLoggedInNavigation() {
    if (this.auth.getRedirectURL() && this.auth.getRedirectURL().length > 0) {
      this.router.navigateByUrl(this.auth.getRedirectURL());
      this.auth.resetRedirectURL();
    } else {
      this.router.navigate(['orders/current']);
    }
  }

}
